import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { signout } from "../../redux/actions";
import { useDispatch } from "react-redux";

const userProfileInfo = {
  name: "Md Shefat Zeon",
  imgurl: "",
};

const OverView = () => {
  const dealer = JSON.parse(localStorage.getItem("dealer"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">My WristLink </h1>

      <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 justify-center items-start">
        {/* CARD 1 */}
        <div className="">
          <CardHeader
            icon={"https://cdn-icons-png.flaticon.com/128/9187/9187475.png"}
            title={"Profile"}
            navLink={""}
          />
          <div className="border rounded-lg p-4 flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              {" "}
              <img
                src={dealer?.avatar}
                height={72}
                width={72}
                className="rounded-full border"
                alt=""
              />
              <div>
                <p className="lg:text-[20px] md:text-[18px] sm:text-[14px] ">
                  {dealer?.auth?.name}
                </p>
                <p className="lg:text-[16px] md:text-[14px] sm:text-[10px] ">
                  {dealer?.companyTitle}, {dealer?.country}
                </p>
              </div>
            </div>
            <div
              onClick={() => dispatch(signout())}
              className="text-white bg-black px-2 py-1 rounded-lg"
            >
              <p>Log Out</p>
            </div>
          </div>
        </div>
        {/* CARD 2 */}
        <div className="">
          <CardHeader
            icon={"https://cdn-icons-png.flaticon.com/128/12864/12864854.png"}
            title={"Sell"}
            navLink={""}
          />
          <div className="border rounded-lg p-4">
            <p className="lg:text-[20px] md:text-[18px] sm:text-[16px] ">
              Sell Your Watch
            </p>

            <button
              className="bg-black text-white py-2.5 rounded-lg w-full"
              onClick={() => navigate("/user/create-listing")}
            >
              {" "}
              Learn More
            </button>

            <button
              className="bg-black lg:hidden md:hidden sm:block text-white py-2.5 rounded-lg w-full mt-4"
              onClick={() => navigate("/user/my-inventory")}
            >
              {" "}
              My Inventory
            </button>
          </div>
        </div>
        {/* CARD 3 */}
        <div className="">
          <CardHeader
            icon={"https://cdn-icons-png.flaticon.com/128/3356/3356653.png"}
            title={"WristLink  Newsletter"}
            navLink={""}
          />
          <div className="border rounded-lg p-4">
            <p className="lg:text-[20px] md:text-[18px] sm:text-[16px] ">
              Stay in the Know
            </p>
            <p className="text-[14px] my-2">
              Beautiful watches, exciting offers, and helpful information.
              Subscribe now for free.
            </p>

            <div className="form-group mb-4">
              <input
                type="text"
                id="email"
                name="email"
                required
                className="mt-1 mb-4 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
                placeholder="Enter your email"
              />
              <div className="flex  items-start mb-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    id="userLoginPagePermanently"
                    name="LoginPagePermanently"
                    className="mr-2"
                  />
                </div>
                <p className="text-[14px]">
                  I would like to receive{" "}
                  <Link
                    to="https://www.chrono24.com/info/datenschutz.htm"
                    target="_blank"
                    className="underline"
                  >
                    newsletters
                  </Link>{" "}
                  about price changes, financial performance updates, the latest
                  trends, and new listings via email. I am aware that I can
                  unsubscribe from these newsletters at any time.
                </p>
              </div>
            </div>

            <button className="bg-black text-white py-2.5 rounded-lg w-full">
              {" "}
              Subscribe now for free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverView;

const CardHeader = ({ icon, title, navLink }) => {
  return (
    <div className="flex justify-between items-center gap-4 mb-2.5">
      <div className="flex items-center gap-2">
        <img src={icon} height={22} width={22} alt="" />
        <p className="lg:text-[22px] md:text-[20px] sm:text-[18px] ">{title}</p>
      </div>
    </div>
  );
};
